import React from "react";
import { IconBase, type IconProps } from "./IconBase";
import calendarSVG from "images/icons/calendar.svg";

export const CalendarIcon = (props: IconProps) => {
  return <IconBase {...props} href={calendarSVG} />;
};
